export const CHAT_BASE_URL = 'https://chat.kapa.ai';

export const buildChatUrl = (
  projectId: string,
  searchParams?: Record<string, string>,
): string => {
  const search = new URLSearchParams(searchParams).toString();
  const path = `${CHAT_BASE_URL}/${encodeURIComponent(projectId)}`;
  return search ? `${path}?${search}` : path;
};
